import { Button, Icon } from '@/components/ui';

/**
 * The action slot of a plan that cannot be chosen yet, with the reason the
 * server gave (`plan.locked_reason`) -- a monthly plan while a paid yearly one
 * still has time left. Shown before anyone clicks, rather than as an error
 * after they have.
 */
export function PlanLockedAction({ reason }) {
  return (
    <div>
      <Button variant="secondary" className="w-full" disabled>
        <Icon name="clock" size={15} />
        Not available yet
      </Button>
      <p className="text-ink-muted mt-2 text-xs leading-5">{reason}</p>
    </div>
  );
}
